var React = require('react');

function IconCheckmarkCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(.5)"},[React.createElement("circle",{"cx":"18","cy":"18","r":"14","className":"timer-circle","key":0}),React.createElement("circle",{"cx":"18","cy":"18","r":"16","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("g",{"fill":"currentColor","key":2},[React.createElement("path",{"d":"M16.203 25.454l-1.637-1.637L24.923 13.46l1.637 1.637z","key":0}),React.createElement("path",{"d":"M9.447 18.745l1.637-1.637 6.746 6.747-1.637 1.637z","key":1})])])));
}

IconCheckmarkCircle.defaultProps = {"viewBox":"0 0 38 38"};

module.exports = IconCheckmarkCircle;

IconCheckmarkCircle.default = IconCheckmarkCircle;
